export interface IAppDataSearch {
    _id: string;
    createBy: string;
    dimensions: { key:string,value:string }[];
    AppIdentifier: string[];
    AppStoreIdentifier: { key: string; value: string }[];
    categories: { key: string; value: string }[];
    appNames: { key: string; value: string }[];
}



export const initAppDataSearch:IAppDataSearch = {
    _id: null,
    createBy: '',
    dimensions: [  { key: 'AppIdentifier', value: 'App Bundle' }],
    AppIdentifier: [],
    AppStoreIdentifier: [],
    categories: [],
    appNames: [],
}

export const appDataFields = [
    'AppIdentifier',
    'AppStoreIdentifier',
    'appStoreUrl',
    'developerUrl',
    'categories',
    'appName',
];

export const appDataFieldsMap = [
    { key: 'AppIdentifier', value: 'App Bundle' },
    { key: 'AppStoreIdentifier', value: 'App Store' },
    { key: 'appStoreUrl', value: 'App Store Url' },
    { key: 'developerUrl', value: 'Developer Url' },
    { key: 'categories', value: 'App Category' },
    { key: 'appName', value: 'App Name' },
]

export const appStoresIdentifier = [
    { key: 'Roku', value: 'Roku' },
    { key: 'iOS App Store', value: 'iOS App Store' },
    { key: 'LG', value: 'LG' },
    { key: 'iOS App Store', value: 'iOS App Store' },
    { key: 'Amazon', value: 'Amazon' },
    { key: 'Samsung', value: 'Samsung' },
    { key: 'Vizio', value: 'Vizio' },
    { key: 'Google Play', value: 'Google Play' },
    ]



export interface IValidationErrors {
    dimensions:string,
    bundles:string,
}


